'use client';

import {useQuestionsStore} from '@components/LiveEvent/@hooks';
import {Pagination} from '@config/pagination';
import {QueryKey} from '@config/queryKeys';
import {QuestionsSortDirEnum} from '@services/live-event/live-event.model';
import LiveEventService from '@services/live-event/live-event.service';
import {useInfiniteQuery} from '@tanstack/react-query';
import {getNextPageOffset} from '@utils/getNextPageOffset';
import {useCurrentLiveEventId} from './useCurrentLiveEventId';

export const useQuestionsQuery = () => {
    const eventId = useCurrentLiveEventId();

    const sortByFilter = useQuestionsStore(s => s.sortByFilter);

    const query = useInfiniteQuery({
        queryKey: QueryKey.LIVE_EVENT_QUESTIONS(eventId!, sortByFilter),
        queryFn: async ({pageParam}) => {
            const fixedParams = {
                offset: pageParam,
                limit: Pagination.LIVE_EVENT_QUESTIONS,
                sortDir: QuestionsSortDirEnum.DESCENDING,
            };

            return LiveEventService.getQuestionsFiltered({
                ...fixedParams,
                webinarId: eventId!,
                sortBy: sortByFilter,
            });
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, _, lastPageParam) => {
            return getNextPageOffset(
                Pagination.LIVE_EVENT_QUESTIONS,
                lastPageParam,
                lastPage.count,
            );
        },
    });

    return {query};
};
